/* Complete Anti-Wrinkle System — image lightbox (robust).

   A click on any [data-caws-lightbox] trigger opens the nearest scope's
   overlay showing the full image. Listens on `window` in the capture phase so
   the theme's own document/body click handlers can't swallow the click first.

   On open the overlay is moved to <body> so it is a true viewport overlay:
   Shrine Pro puts transform/animation on section wrappers, which would
   otherwise make our position:fixed overlay resolve relative to the section
   (and get clipped by the section's overflow) — the classic "backdrop shows,
   image doesn't" bug. Reparenting to <body> escapes any ancestor transform,
   filter, or overflow. The full image URL comes from the trigger's data-full,
   falling back to the visible thumbnail's own src so it can never be empty.
   Closes on the close button, a backdrop click, or Esc. */
(function () {
  if (window.__cawsLightboxInit) return;
  window.__cawsLightboxInit = true;

  var openOverlay = null;

  function fullSrcFor(trigger) {
    var full = trigger.getAttribute('data-full');
    if (full) return full;
    var thumb = trigger.querySelector('img');
    if (thumb) return thumb.currentSrc || thumb.src || '';
    return '';
  }

  function open(trigger) {
    var scope = trigger.closest('[data-caws-lightbox-scope]');
    if (!scope) return;
    var overlay = scope.querySelector('[data-caws-lightbox-dialog]');
    if (!overlay) return;
    var img = overlay.querySelector('[data-caws-lightbox-img]');
    var full = fullSrcFor(trigger);
    if (img && full) {
      img.src = full;
      img.alt = trigger.getAttribute('data-alt') || '';
    }
    // Move the overlay out to <body> so position:fixed is relative to the
    // viewport, not a transformed section ancestor. Remember where it came
    // from so we can restore it on close (keeps the theme editor happy).
    if (overlay.parentNode !== document.body) {
      overlay.__cawsHome = overlay.parentNode;
      document.body.appendChild(overlay);
    }
    overlay.hidden = false;
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    openOverlay = overlay;
  }

  function close(overlay) {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
    var img = overlay.querySelector('[data-caws-lightbox-img]');
    if (img) img.removeAttribute('src');
    // Put the overlay back where it lived in the section markup.
    if (overlay.__cawsHome) {
      overlay.__cawsHome.appendChild(overlay);
      overlay.__cawsHome = null;
    }
    if (openOverlay === overlay) openOverlay = null;
  }

  window.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('[data-caws-lightbox]');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        open(trigger);
        return;
      }
      var closer = event.target.closest('[data-caws-lightbox-close]');
      if (closer) {
        event.preventDefault();
        event.stopPropagation();
        close(closer.closest('[data-caws-lightbox-dialog]'));
        return;
      }
      var ov = event.target.closest('[data-caws-lightbox-dialog]');
      if (ov && event.target === ov) {
        close(ov);
      }
    },
    true
  );

  window.addEventListener(
    'keydown',
    function (event) {
      if (event.key === 'Escape' && openOverlay) close(openOverlay);
    },
    true
  );
})();
